module.exports = __webpack_public_path__ + "static/media/likeIcn.2b29c081.png";